import Immutable from 'immutable';


const LOAD = 'sageAccount/LOAD';
const LOAD_SUCCESS = 'sageAccount/LOAD_SUCCESS';
const LOAD_FAIL = 'sageAccount/LOAD_FAIL';

const initialState = Immutable.fromJS({
    isLoad: false,
    loadErr: null,
    loading: false,
    sageAccounts: []
});

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case LOAD:
            return state
                .set('isLoad', true)
                .set('loadErr', null);

        case LOAD_SUCCESS:
            return state
                .set('isLoad', false)
                .set('loadErr', null)
                .set('sageAccounts', action.res);

        case LOAD_FAIL:
            return state
                .set('isLoad', false)
                .set('loadErr', action.error)
                .set('sageAccounts', []);

        default:
            return state;
    }
};


export const getSageAccounts = () => async (dispatch, getState, api) => {
    dispatch({ type: LOAD });
    try {
        let res = await api.get(`/sageAccount`);
        dispatch({ type: LOAD_SUCCESS, res: res });
        return res;
    } catch (err) {
        dispatch({ type: LOAD_FAIL, error: err.message });
    }
};